import { createDealerWorkflowLayout } from './createDealerWorkflowLayout';

export const CUSTOMER_RISK_LAYOUT = createDealerWorkflowLayout([
  { type: 'customerCredits', title: 'Customer Credit' },
  { type: 'customerTransfersBlotter', title: 'Customer Transfers' },
  { type: 'customerBalancesBlotter', title: 'Customer Balances' },
]);
